import { apiFetch } from './client';

export interface Notification {
  id: string;
  userId: string;
  type: string;
  title: string;
  message?: string;
  metadata?: Record<string, unknown>;
  read: boolean;
  createdAt: string;
}

export interface NotificationListResponse {
  notifications: Notification[];
  total: number;
}

export interface NotificationFilters {
  page?: number;
  limit?: number;
  unreadOnly?: boolean;
}

export const getUnreadCount = async (): Promise<{ count: number }> => {
  return apiFetch<{ count: number }>('/notifications/unread-count');
};

export const listNotifications = async (
  filters: NotificationFilters = {},
): Promise<NotificationListResponse> => {
  const params = new URLSearchParams();

  if (filters.page !== undefined) params.set('page', String(filters.page));
  if (filters.limit !== undefined) params.set('limit', String(filters.limit));
  if (filters.unreadOnly !== undefined) params.set('unreadOnly', String(filters.unreadOnly));

  const query = params.toString();
  return apiFetch<NotificationListResponse>(`/notifications${query ? `?${query}` : ''}`);
};

export const markAllAsRead = async (): Promise<{ message: string; count: number }> => {
  return apiFetch<{ message: string; count: number }>('/notifications/read-all', {
    method: 'PUT',
  });
};

export const markAsRead = async (id: string): Promise<{ message: string }> => {
  return apiFetch<{ message: string }>(`/notifications/${id}/read`, {
    method: 'PUT',
  });
};

export const deleteNotification = async (id: string): Promise<{ message: string }> => {
  return apiFetch<{ message: string }>(`/notifications/${id}`, {
    method: 'DELETE',
  });
};
